import "./App.css";
import { useEffect, useRef, useState } from "react";

function App() {
  const [show, setShow] = useState(false);
  const [result, setResult] = useState(0.0);
  const [per, setPer] = useState(0.0);
  const amountRef = useRef(0);
  const peopleRef = useRef(1);

  const handleShow = () => {
    if (show === false) {
      setShow(true);
    }
  };
  const handleHidden = () => {
    if (show === true) {
      setShow(false);
    }
  };

  const handleCustom = (e) => {
    console.log("Done");
  };
  const handleInput = (e) => {
    console.log("Done");
    const amount = amountRef.current.value;
    const people = peopleRef.current.value;
    const result = (e * amount) / 100;
    const amountPerPerson = result / people;
    setResult(result.toFixed(2));
    setPer(amountPerPerson.toFixed(2));
  };
  const handleBothFunctions = (e) => {
    handleHidden();
    handleInput(e);
  };

  const handleReset = () => {
    setResult(0);
    setPer(0);
    amountRef.current.value = 0;
    peopleRef.current.value = 0;
  }

  return (
    <div className="App">
      <div className="header">
        <h1>spli</h1>
        <h1>tter</h1>
      </div>
      <div className="card">
        <div className="left">
          <div>
            <label>Bill</label>
            <div className="bill">
              <img src="icon-dollar.svg" alt="" />

              <input type="text" placeholder="0" dir="rtl" ref={amountRef} />
            </div>
          </div>

          <div>
            <label>Select Tip %</label>
            <div className="tip">
              <button className="per" onClick={() => handleBothFunctions("5")}>
                5%
              </button>
              <button className="per" onClick={() => handleBothFunctions("10")}>
                10%
              </button>
              <button className="per" onClick={() => handleBothFunctions("15")}>
                15%
              </button>
              <button className="per" onClick={() => handleBothFunctions("25")}>
                25%
              </button>
              <button className="per" onClick={() => handleBothFunctions("50")}>
                50%
              </button>
              {show === false ? (
                <button className="per custom" onClick={handleShow}>
                  Custom
                </button>
              ) : (
                <input
                  className="custom"
                  type="text"
                  placeholder="0"
                  dir="rtl"
                  onChange={handleCustom}
                />
              )}
            </div>
          </div>

          <div>
            <label>Number of People</label>
            <div className="bill">
              <img src="icon-person.svg" alt="" />
              <input type="text" placeholder="0" dir="rtl" ref={peopleRef} />
            </div>
          </div>
        </div>

        <div className="right">
          <div className="container">
            <div>
              <p>
                Tip Amount <span>/ person</span>
              </p>
              <h1>
                <span>$</span>
                {per}
              </h1>
            </div>
            <div>
              <p>
                Total <span>/ person</span>
              </p>
              <h1>
                <span>$</span>
                {result}
              </h1>
            </div>
          </div>
          <button className="reset" onClick={handleReset}>Reset</button>
        </div>
      </div>
    </div>
  );
}

export default App;
